const guruURL = process.env.REACT_APP_GURU_URL;

const HandlePostIdUrl = (id) => (id ? `${guruURL}/?p=${id}` : '');

export default HandlePostIdUrl;
